import { isBrowser, isAngular1, isProduction } from './utils/environment'
import { importHTTP } from './utils/http'
import { pclnHTTPWebHandler } from './handlers/pcln-http-web.js'
import PCLNAnalytics from './pcln-analytics'
import CONFIG from './config'

const DEBUG_MODE = isBrowser() && !isProduction()
const config = CONFIG()
const PCLN_ANALYTICS = new PCLNAnalytics({
  name: config.NAME,
  version: config.VERSION,
  debug: DEBUG_MODE,
  GAEnabled: isBrowser(),
  batchMeta: () => {
    const appData = CONFIG()

    return {
      appName: appData.APP_NAME,
      appVersion: appData.APP_VERSION,
      appLocale: appData.APP_LOCALE,
    }
  },
})

importHTTP(pclnHTTPWebHandler)

export default PCLN_ANALYTICS

if (isBrowser()) {
  if (isAngular1()) {
    window.angular.module('pcln.analytics', []).factory('PCLNAnalytics', () => PCLN_ANALYTICS)
  } else {
    // Cleanup namespace from built umd library
    window.PCLN = window.PCLN || {}
    window.PCLN.Analytics = PCLN_ANALYTICS
  }

  setTimeout(() => delete window.PCLNAnalytics)
}
